module.exports = __webpack_public_path__ + "static/media/maybe-ico-grayed.83fbfd9c.svg";